/**
 * 加价购相关的值定义
 */

/**
 * planType 加价购_方案类型
 */
export const MarkUpPlanType = {
  FullVolumePromotion: 19, // 满量促销
  FullSalesPromotion: 20, // 满额促销
  BuySendGift: 21, // 买赠活动
  BundledSales: 23, // 捆绑销售
};

/**
 * RuleSubjectId 加价购_营销规则
 */
export const RuleSubjectId = {
  FullVolume: 11, // 满量
  FullSales: 12, // 满额
};

/**
 * PolicySubjectId 加价购_营销规则
 */
export const PolicySubjectId = {
  SubjectSend: 12, // 赠送商品
  SubjectAdd: 17, // 加价购商品
};

/**
 * 整合之后的四种规则
 */
export const PurchaseMethod = {
  FullSalesSend: 1, // 满额赠送
  FullSalesAdd: 2, // 满额加价
  FullVolumeSend: 3, // 满量赠送
  FullVolumeAdd: 4, // 满量加价
};

/**
 * MarkUpRuleLogic 加价购_规则逻辑
 */
export const MarkUpRuleLogic = {
  EQ: 1, // 等于
  LTE: 2, // 小于等于
  GTE: 3, // 大于等于
  LT: 7, // 小于
  GT: 8, // 大于
};

/**
 * MarkUpPolicySubjectId 加价购_策略科目类型
 */
export const MarkUpPolicySubject = {
  ChangePurchase: 17, // 加价购_策略科目类型_换购
};

/**
 * MarkUpPolicyDetail 加价购_策略细节类型
 */
export const MarkUpPolicyDetail = {
  // 加价购_策略细节类型_加价购商品
  // 171 表示 加价金额：policy_value1, 赠送数量：policy_value2
  // 满量或满额后，加X元，赠送N份赠送商品
  ChangePurchase: 171,

  // 加价购_策略细节类型_赠送商品
  // 121 表示 赠送商品 赠送数量：policy_value1
  // 指定商品满额或满量，赠送指定商品数量N份
  SendPurchase: 121,
};

/**
 * MarkUpActivityDishType 加价购_享受活动的商品
 */
export const MarkUpActivityDishType = {
  SINGLEDISH: 1, // 单菜品
  MIDDISH: 2, // 中类菜品
};



// WEBPACK FOOTER //
// ./src/helper/const/change-purchase.js